import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { SafetyDialogComponent } from '../safety-dialog/safety-dialog.component';
import { SafetyService } from 'src/app/services/safety.service';
import { BtnDownload } from 'src/app/btn-download.component';
import { TranslaterService } from 'src/app/services/translater.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import { BaseApi } from 'src/backend/api/base-api';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Component({
  selector: 'app-incident-reporting',
  templateUrl: './incident-reporting.component.html',
  styleUrls: ['./incident-reporting.component.scss']
})
export class IncidentReportingComponent implements OnInit {
  isEdit: boolean = false;
  user: any;
  breadcrumList: any;
  spinnerText: string = "";
  paginationPageSize!: any;

  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    paginationPageSize: 5,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      BtnRenderer: BtnDownload,
    },
  };
  gridApi!: any;
  gridColumnApi!: any;

  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  IncidentReportColumns = [
    { field: 'Pudesc', headerName: 'Unit', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'Date', headerName: 'Date', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'IncidentTypeName', headerName: 'Incident Type', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'IncidentOn', headerName: 'Incident On', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'Classification', headerName: 'Incident Classification', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'InjuredPerson', headerName: 'Injured Person', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'DetailDescription', headerName: 'Detail Description', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'CreatedOn', headerName: 'Created On', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'CreatedBy', headerName: 'Created By', headerValueGetter: this.localizeHeader.bind(this) },
    {
      field: 'FileDoc',
      headerName: 'File',
      cellRenderer: this.swotpestColumnRender.bind(this),
      autoHeight: true,
      headerValueGetter: this.localizeHeader.bind(this)
    }
  ];

  IncidentReportList: any = [];
  IncidentReportFileUrl: any;
  languageDir = 'ltr';
  lang: any;
  moduleId: any;
  pageId: any;
  langObj: any;
  userMenus: any;
  constructor(
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    public safetyService: SafetyService,
    private translater: TranslaterService,
    private translate: TranslateService,
    private baseApi: BaseApi
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); })
  }

  ngOnInit(): void {
    this.pageId = this.baseApi.getCurrentMenuID();
    this.userMenus = this.baseApi.getUserPermissionsSession();
    this.IncidentReportFileUrl = Constants.BLOB_STORAGE_URL;
    this.user = localStorage.getItem('user');
    this.user = JSON.parse(this.user);
    this.getLangWords();
  }

  swotpestColumnRender(params: any) {

    let html = '';
    if (params && params.data && params.data.FileDoc) {
      if (params.data.FileDoc.match('png.*') || params.data.FileDoc.match('jpg.*') || params.data.FileDoc.match('jpeg.*')) {
        html = `<a target="_blank" href="${this.IncidentReportFileUrl + params.data.FileDoc}" class="down_icon" download>
        <img src="${this.IncidentReportFileUrl + params.data.FileDoc}" width="60" height="45" alt="pdf">
        </a>`
      }
      else {
        html = `<a target="_blank" href="${this.IncidentReportFileUrl + params.data.FileDoc}" class="down_icon" download>
        <img src="../../../assets/images/file-down.png" width="50" height="40" alt="pdf">
        </a>`
      }

    }
    return html;

  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  applyFilter(event: Event): void {
  }

  getIncidentReport(event: any) {
    this.spinner.show();
    this.spinnerText = "Fetching Incident Report";
    this.safetyService.getIncidentReport(event).subscribe((res: any) => {
      this.spinner.hide();
      this.IncidentReportList = res.IncidentReportList;
      this.getPaginator();
    },
      (error: any) => {
        this.toaster.error(error.error.message);
        this.spinner.hide();
      });
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getPaginator(): void {
    setTimeout(() => {
    }, 100);
  }

  openDialog(event: any, name: any): void {
    let dialogRef = this.dialog.open(SafetyDialogComponent, {
      disableClose: true,
      width: '50%',
      height: 'auto',
      data: {
        headerData: event,
        formName: name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result == undefined)
        console.log('Undefined Result');
      else
        this.getIncidentReport(result);
    });
  }
}
